import { createPrivateNodeRequestPayload, newUserPrivateNodeRequestPayload, updateUserInformationPayload } from "../interfaces/account.interface";
import { getAuthHeader } from "../utils/methods";
import http from "../httpConfig";
import { ApiPath } from "../utils/apiConstants";

const createPrivateNodeRequest = (payload: createPrivateNodeRequestPayload) => {
    return http.post(ApiPath.privateNodeRequest, payload, { headers: getAuthHeader() });
}

const createNewUserPrivateNodeRequest = (payload: newUserPrivateNodeRequestPayload) => {
    return http.post(ApiPath.newUserPrivateNodeRequest, payload);
}

const getPrivateNodeRequestStatus = () => {
    return http.get(ApiPath.getPrivateNodeRequestStatus, { headers: getAuthHeader() });
}

const updatePrivateNodeRequestStatus = (requestId: number) => {
    return http.put(ApiPath.updatePrivateNodeRequestStatus, { requestId }, {headers: getAuthHeader()});
}

const updateUserInformation = (payload: updateUserInformationPayload) => {
    return http.put(ApiPath.users + ApiPath.updateUserInformation, payload, { headers: getAuthHeader() });
}

const AccountService = {
    createPrivateNodeRequest,
    createNewUserPrivateNodeRequest,
    getPrivateNodeRequestStatus,
    updatePrivateNodeRequestStatus,
    updateUserInformation
};

export default AccountService; 